/* istanbul ignore file */

import PropTypes from 'prop-types';

const lastTimestampShape = PropTypes.shape({
  epochSecond: PropTypes.number.isRequired,
  nano: PropTypes.number.isRequired,
});

const tagShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
});

const conversionShape = PropTypes.shape({
  units: PropTypes.string.isRequired,
});

const channelShape = PropTypes.shape({
  channelKey: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  adjust: PropTypes.number.isRequired,
  conversion: conversionShape.isRequired,
});

const channelGroupShape = PropTypes.shape({
  channels: PropTypes.arrayOf(channelShape).isRequired,
  channelKey: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  lastReceived: lastTimestampShape.isRequired,
});

const sensorShape = PropTypes.shape({
  channelGroups: PropTypes.arrayOf(channelGroupShape).isRequired,
  macAddress: PropTypes.string.isRequired,
  channelKey: PropTypes.string.isRequired,
});

// eslint-disable-next-line import/prefer-default-export
export const deviceDataPropTypes = PropTypes.shape({
  general: PropTypes.shape({
    name: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    tagList: PropTypes.arrayOf(tagShape).isRequired,
    uptime: PropTypes.string.isRequired,
    macAddress: PropTypes.string.isRequired,
    lastMessageTimestamp: lastTimestampShape.isRequired,
    isSuspended: PropTypes.bool.isRequired,
    capacityJson: PropTypes.string.isRequired,
    geocode: PropTypes.any,
    pushInterval: PropTypes.number.isRequired,
    deviceType: PropTypes.string.isRequired,
    ethIp: PropTypes.string.isRequired,
    linkName: PropTypes.any,
    serialnumber: PropTypes.string.isRequired,
    firmware: PropTypes.string.isRequired,
    isHttps: PropTypes.bool.isRequired,
    wlanIp: PropTypes.any,
    httpPort: PropTypes.number.isRequired,
    linkId: PropTypes.any,
    wifiName: PropTypes.any,
    pushStatus: PropTypes.number.isRequired,
    isLinkConnected: PropTypes.bool.isRequired,
    warrantyEndDate: PropTypes.any,
    deviceAssignmentStartDate: lastTimestampShape.isRequired,
    publicPageHash: PropTypes.string.isRequired,
  }).isRequired,
  sensors: PropTypes.arrayOf(sensorShape).isRequired,
});
